export default __webpack_public_path__ + "static/media/ChristineJones-3.535efa9e.jpg";